import { FilterList } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { READABLE_SECONDARY_SX, READABLE_TITLE_SX } from "src-next/modules/clinical-insights/constants/clinicalInsightsTheme";

interface InsightFilterPanelHeaderProps {
  practitionerFilter?: ReactNode;
}

export function InsightFilterPanelHeader({
  practitionerFilter,
}: InsightFilterPanelHeaderProps) {
  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={1} alignItems="center">
        <FilterList sx={{ fontSize: 28, color: "text.secondary" }} />
        <Box>
          <Typography fontWeight={700} sx={READABLE_TITLE_SX}>
            Filtrar pacientes
          </Typography>
          <Typography color="text.secondary" sx={READABLE_SECONDARY_SX}>
            Marque um ou mais itens
          </Typography>
        </Box>
      </Stack>
      {practitionerFilter ? (
        <Stack spacing={1}>
          <Typography fontWeight={700} sx={READABLE_TITLE_SX}>
            Profissional
          </Typography>
          <Box>{practitionerFilter}</Box>
        </Stack>
      ) : null}
    </Stack>
  );
}
